import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const DrivingRecord: React.FC = () => {
  return (
    <PlaceholderPage
      title="Driving Record"
      description="Access driver history and violation records"
    />
  );
};

export default DrivingRecord;
